import { FileCsvIcon as e } from "./FileCsvIcon.js";
import { FileDocIcon as t } from "./FileDocIcon.js";
import { FileGenericIcon as n } from "./FileGenericIcon.js";
import { FileImageIcon as r } from "./FileImageIcon.js";
import { FileJsonIcon as i } from "./FileJsonIcon.js";
import { FilePdfIcon as a } from "./FilePdfIcon.js";
import { FilePptIcon as o } from "./FilePptIcon.js";
import { FileTxtIcon as s } from "./FileTxtIcon.js";
import { FileXlsIcon as c } from "./FileXlsIcon.js";
import { FileXmlIcon as l } from "./FileXmlIcon.js";
import { FileZipIcon as u } from "./FileZipIcon.js";
import { FolderIcon as d } from "./FolderIcon.js";
import { FolderOpenIcon as f } from "./FolderOpenIcon.js";
import { jsx as p } from "react/jsx-runtime";
//#region src/components/file-types/FileTypeIcon.tsx
var m = {
	pdf: a,
	doc: t,
	xls: c,
	csv: e,
	ppt: o,
	txt: s,
	image: r,
	json: i,
	xml: l,
	zip: u,
	generic: n,
	folder: d,
	"folder-open": f
}, h = ({ kind: e, ...t }) => {
	let n = m[e];
	return /* @__PURE__ */ p(n, { ...t });
};
//#endregion
export { h as FileTypeIcon };
